import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const Remote = (props) => (<Svg {...props}>
    <Path d="M13.167 2H3.833a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h4v1.334H5.168a.667.667 0 1 0 0 1.333h6.667a.666.666 0 1 0 0-1.333H9.167v-1.334h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm.667 7.333a.666.666 0 0 1-.667.667H3.833a.667.667 0 0 1-.666-.667V4a.667.667 0 0 1 .667-.667h9.333a.667.667 0 0 1 .667.667v5.333Z" fill={props.color ?? '#FF9138'}/>
  </Svg>);
export default Remote;
